import React from 'react';

import { Col, Flex, Row, Typography } from 'antd';

import Content from 'components/_Common/_Layout/Content';
import { CreateGuestLogForm } from 'components/Guest/Log/CreateGuestLogForm';
import { GuestsLogsList } from 'components/Guest/Log/GuestsLogsList';
import { GuestsLogsPageCard } from 'components/Guest/Log/GuestsLogsPageCard';
import { GuestsLogsVehicleAlertCard } from 'components/Guest/Log/GuestsLogsVehicleAlertCard';
import { GuestsLogsContextProvider } from 'lib/providers/GuestsLogsContextProvider';

// TODO(249): Add Griw again. Form is 30% and List is 70% (or auto)
// TODO(249): Add limit to some List columns, such as CPF, dates and vehicle plate
// TODO(249): Canceled list items need custom style (----)

export function GuestsLogs() {
    return (
        <GuestsLogsContextProvider>
            <Content>
                <Row justify="space-between" align="middle">
                    <Typography.Title level={3}>
                        Visitantes
                    </Typography.Title>
                </Row>

                <Flex vertical gap="middle">
                    <Row>
                        <Col xs={24} sm={24} md={18} lg={18}>
                            <GuestsLogsPageCard title="Cadastrar entrada de visitante">
                                <CreateGuestLogForm />
                            </GuestsLogsPageCard>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6}>
                            <GuestsLogsPageCard title="Alertas de veículos">
                                <GuestsLogsVehicleAlertCard />
                            </GuestsLogsPageCard>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <GuestsLogsPageCard title="Lista de entradas de visitantes">
                                <GuestsLogsList />
                            </GuestsLogsPageCard>
                        </Col>
                    </Row>
                </Flex>
            </Content>
        </GuestsLogsContextProvider>
    );
}
